import {
  ACTIVE_LOADING,
  DEACTIVATE_LOADING,
  SET_LOADING,
  SET_DEVICE_HEIGHT,
  SET_ERROR_STATE,
  SET_MAINTENANCE,
  SET_ADDITIONAL_INFO,
} from 'redux/actions/types';
const initialState = {
  isLoading: false,
  isError: false,
  deviceHeight: 0,
  maintenance: {
    isMaintenance: false,
  },
  additionalInfo: {
    dgos_goods_id: '',
  },
};
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case DEACTIVATE_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_ERROR_STATE:
      return {
        ...state,
        isError: action.payload,
      };
    case SET_DEVICE_HEIGHT:
      return {
        ...state,
        deviceHeight: action.payload,
      };
    case SET_MAINTENANCE:
      return {
        ...state,
        maintenance: action.payload,
      };
    case SET_ADDITIONAL_INFO:
      return {
        ...state,
        additionalInfo: action.payload,
      };
    default:
      return state;
  }
};
